import { observer } from 'mobx-react-lite'
import {
  useEventIntegrationConnected,
  useEventIntegrationDisconnected,
} from 'entities/Integrations'
import {
  useEventOrganizationCalling,
  useEventUpdateBalance,
  useEventUserAwayStatusChanged,
  useEventOrganizationRestrictionRemoved,
} from 'entities/Organization'
import { useEventInboxCalling } from 'entities/Inbox'
import { useEventMessagePopper } from 'entities/Message'
import {
  useEventConversationContactOptedIn,
  useEventConversationContactOptedOut,
  useEventConversationReassigned,
} from 'entities/Conversation'
import {
  useEventContactUpdated,
  useEventConversationShortcodeOptOutChanged,
} from 'entities/Contacts'
import { useEventClientDraft } from 'entities/Conversation/events/EventClientDraft'
import { useEventMessageDeletedDraft } from 'entities/Conversation/events/EventMessageDeletedDraft'
import { useEventInboxUpdate } from 'entities/Inbox/events/EventInboxUpdate'
import { useEventInboxDeleted } from 'entities/Inbox/events/EventInboxDeleted'
import { useEventInboxCreated } from 'entities/Inbox/events/EventInboxCreated'
import { useEventMessagePopperLog } from 'entities/DataLog/events/EventMessagePopperLog'
import { useEventMessageReceivedNewLog } from 'entities/DataLog/events/EventMessageReceivedNewLog'
import { useEventMessageUpdatedNewLog } from 'entities/DataLog/events/EventMessageUpdatedNewLog'
import { useEventConversationUnreadLog } from 'entities/DataLog/events/EventConversationUnreadLog'
import { useEventConversationStateChanged } from 'entities/Conversation/events/EventConversationStateChanged'
import { useEventNumberCallerIdVerification } from 'entities/Phone/events/EventNumberCallerIdVerification'
import { useGlobalEventSettingsNumbersUnassignedRefreshFinished } from 'entities/Phone/events/EventSettingsNumbersUnassignedRefreshFinished'
import { useEventUserPermissionsUpdated } from 'entities/UsersPermissions/events/EventPermissionsUpdated'
import { useEventInboxMemberRemoved } from 'entities/Inbox/events/EventInboxMemberRemoved'
import { useEventInboxMemberAdded } from 'entities/Inbox/events/EventInboxMemberAdded'
import { useEventToggleRingEverywhere } from 'entities/Users/events/EventToggleRingEverywhere'
import { useEventToggleRecordAutomatically } from 'entities/Users/events/EventToggleRecordAutomatically'
import { useEventCallTransferStarted } from 'entities/Call/events/EventCallTransferStarted'
import { useEventCallTransferFailed } from 'entities/Call/events/EventCallTransferFailed'
import { useEventAccessRequestRevoked } from 'entities/Users/events/EventAccessRequestRevoked'

export const GlobalEvents = observer(() => {
  useEventClientDraft()
  useEventConversationStateChanged()
  useEventMessageDeletedDraft()
  useEventConversationUnreadLog()
  useEventMessagePopperLog()
  useEventMessageReceivedNewLog()
  useEventMessageUpdatedNewLog()
  useEventInboxCreated()
  useEventInboxDeleted()
  useEventInboxUpdate()
  useEventIntegrationConnected()
  useEventIntegrationDisconnected()
  useEventUpdateBalance()
  useEventOrganizationCalling()
  useEventInboxCalling()
  useEventConversationContactOptedOut()
  useEventConversationContactOptedIn()
  useEventConversationReassigned()
  useEventMessagePopper()
  useEventContactUpdated()
  useEventConversationShortcodeOptOutChanged()
  useEventNumberCallerIdVerification()
  useEventUserAwayStatusChanged()
  useGlobalEventSettingsNumbersUnassignedRefreshFinished()
  useEventOrganizationRestrictionRemoved()
  useEventUserPermissionsUpdated()
  useEventInboxMemberRemoved()
  useEventInboxMemberAdded()
  useEventToggleRingEverywhere()
  useEventToggleRecordAutomatically()
  useEventCallTransferStarted()
  useEventCallTransferFailed()
  useEventAccessRequestRevoked()

  return null
})
